
import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';


interface TechniquesPerPageSelectorProps {
  itemsPerPage: number;
  onItemsPerPageChange: (value: number) => void;
}

export const TechniquesPerPageSelector: React.FC<TechniquesPerPageSelectorProps> = ({
  itemsPerPage,
  onItemsPerPageChange,
}) => {
  
  const handleValueChange = (value: string) => {
    onItemsPerPageChange(value === 'all' ? 1000 : parseInt(value, 10));
  };

  return (
    <div className="flex items-center justify-center gap-2 mt-4 pt-2 border-t border-border">
      <span className="text-xs sm:text-sm text-muted-foreground">
        Show per page:
      </span>
      <Select
        value={itemsPerPage >= 1000 ? 'all' : String(itemsPerPage)}
        onValueChange={handleValueChange}
      >
        <SelectTrigger className="w-16 h-8 text-xs sm:text-sm">
          <SelectValue placeholder={itemsPerPage >= 1000 ? 'All' : String(itemsPerPage)} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="6">6</SelectItem>
          <SelectItem value="9">9</SelectItem>
          <SelectItem value="12">12</SelectItem>
          <SelectItem value="15">15</SelectItem>
          <SelectItem value="18">18</SelectItem>
          <SelectItem value="all">All</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
